import { defineMessages } from "@/lib/i18n/messages";

// Se muestra en el idioma SUGERIDO (no en el actual): quien la ve es alguien
// cuyo navegador está en ese idioma.
export default defineMessages({
  es: {
    question: "¿Prefieres ver Ciudad Viva en español?",
    accept: "Ver en español",
    dismiss: "No, gracias",
  },
  en: {
    question: "Would you like to view Ciudad Viva in English?",
    accept: "View in English",
    dismiss: "No, thanks",
  },
});
